import React, { useState } from 'react';
import { Bell, Search, User } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/context/AuthContext';

interface HeaderProps {
  sidebarExpanded: boolean;
}

export const Header: React.FC<HeaderProps> = ({ sidebarExpanded }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Use the correct path for navigation
      navigate({ 
        to: '/search',
        search: { q: searchQuery },
        params: {}
      });
    }
  };

  const handleUserClick = () => {
    navigate({ to: '/settings' });
  };

  return (
    // <header className={`flex h-16 items-center border-b border-border bg-background px-4 ${sidebarExpanded ? 'ml-64' : 'ml-16'}`}>
    <header className={`flex h-16 items-center border-b border-border bg-background px-4 ${sidebarExpanded ? 'ml-0' : 'ml-0'}`}>
      <div className="flex flex-1 items-center gap-4">
        <form onSubmit={handleSearch} className="relative w-full max-w-md">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <input
            type="search"
            placeholder="Search documents, profiles, collections..."
            className="h-9 w-full rounded-md border border-input bg-background pl-8 pr-4 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>
      </div>
      <div className="flex items-center gap-4">
        <button className="rounded-full p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground">
          <Bell className="h-5 w-5" />
          <span className="sr-only">Notifications</span>
        </button>
        <div className="relative">
          <button 
            className="flex items-center gap-2 rounded-full p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground"
            onClick={handleUserClick}
          >
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground">
              <User className="h-4 w-4" />
            </div>
            <span className="text-sm font-medium">
              {user?.full_name || user?.username || 'User'}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
